
import axios from 'axios'


// eslint-disable-next-line no-unused-vars


function getdefineAlarm() {
    var urlString = `${process.env.VUE_APP_APIURL}/dashboard/alarm-coverage`;
    return axios
        .get(urlString)
        .then(res => {
            return res.data
        })
}

function getPointHealth() {
    var urlString = `${process.env.VUE_APP_APIURL}/dashboard/recent-point-health`;
    return axios
        .get(urlString)
        .then(res => {
            return res.data
        })
}

function getAlarmOccurence(dayCount, unit, filteredPoints) {
    let pointsValue = filteredPoints.join(',')
    var urlString = `${process.env.VUE_APP_APIURL}/dashboard/time-series/alarm-occurence?dayCount=${dayCount}&unit=${unit}&points=${pointsValue}`;

    return axios
        .get(urlString)
        .then(res => {
            return res.data
        })
}

function getPointRecovery() {
    var urlString = `${process.env.VUE_APP_APIURL}/dashboard/point-recovery`;
    return axios
        .get(urlString)
        .then(res => {
            return res.data
        })
}

function getAlarmTransactions(pageSize,pageNumber,filteredPoints, levelName) {
    let pointsValue = filteredPoints.join(',')
    var urlString = `${process.env.VUE_APP_APIURL}/alarm-transactions?pageSize=${pageSize}&pageNumber=${pageNumber}&points=${pointsValue}&levelName=${levelName}`;
    console.log(urlString)
    return axios
        .get(urlString)
        .then(res => {
            return res.data
        })
}
function getPointHealthScore() {
    var urlString = `${process.env.VUE_APP_APIURL}/dashboard/point-health-score`;
    return axios
        .get(urlString)
        .then(res => {
            return res.data
        })
}
export default {
    getdefineAlarm,
    getPointHealth,
    getAlarmOccurence,
    getPointRecovery,
    getAlarmTransactions,
    getPointHealthScore
};